<template>
  <b-container class="mt-4">
    <b-row>
      <b-col lg="8" class="mb-5">
        <DiscourseSSOLink
          v-if="$store.state.authorized && $store.state.user.emailVerified"
        />
        <div v-if="$store.state.authorized && !$store.state.user.emailVerified">
          <h1>Email verification required</h1>
          <p>
            Forum access requires email verification. Please click below to send
            an email verification link to
            <em>{{ $store.state.user.email }}.</em>
          </p>
          <b-btn
            v-show="!emailSent"
            @click="
              $store.dispatch('sendEmailVerification');
              emailSent = true;
            "
          >
            Send verification email
          </b-btn>
          <p v-show="emailSent" class="alert alert-success">
            Email sent. Please refresh this page after verifying your email.
          </p>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
// @ is an alias to /src
import DiscourseSSOLink from "@/components/DiscourseSSOLink";
export default {
  name: "DiscourseSSO",
  components: {
    DiscourseSSOLink
  },
  data() {
    return {
      emailSent: false
    };
  },
  computed: {
    verified() {
      return (
        this.$store.state.authorized && this.$store.state.user.emailVerified
      );
    }
  }
};
</script>
